var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1091 4.95796C16.7539 8.847 15.0406 13.4305 11.2712 15.2361C10.1747 15.7916 9.00964 16 7.8446 16C6.95368 16 6.06276 15.8611 5.24036 15.5833C3.8697 15.0972 2.70464 14.2638 1.81372 13.1527C1.40252 12.6666 1.05985 12.111 0.785724 11.486C-0.0366709 9.68036 -0.242269 7.6664 0.305993 5.79132C0.305993 5.65244 0.374526 5.51352 0.44306 5.37464C1.12839 3.43014 2.43051 1.90231 4.21236 0.930052C4.28088 0.860604 4.41796 0.79116 4.48648 0.79116C5.3774 0.374478 6.26836 0.0966912 7.2278 0.0272443C7.91312 -0.0422024 8.667 0.0272442 9.35232 0.166138L9.42084 2.94401L9.0782 2.87456C7.91312 2.59678 6.74808 2.73567 5.65156 3.29124C4.34944 3.98571 3.38997 5.0274 2.97877 6.34692C2.49904 7.6664 2.63611 9.12476 3.18437 10.3748C3.32144 10.5832 3.38997 10.7915 3.52703 10.9998C4.14384 11.9721 5.03476 12.6666 6.13128 13.0832C7.09072 13.4305 8.18728 13.4999 9.14672 13.2221C9.4894 13.1527 9.76352 13.0138 10.1062 12.8749C11.888 12.0415 12.916 10.2359 13.0531 8.36084C13.0531 7.6664 12.9846 6.97192 12.7104 6.27744L11.8195 6.7636L11.6824 1.20784L13.5328 2.66622L16 4.61072L15.1091 4.95796Z",
    fill: "#8D9193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconGray);
export default __webpack_public_path__ + "static/media/TH-Icon-Gray.55740bef758fe60794d8f11e244d0210.svg";
export { ForwardRef as ReactComponent };